<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Vue from "vue";

export default {
  created() {
    Vue.prototype.$vs = this.$vs;
  },

  watch: {
    $route(to) {
      this.loadFreshworksWidgetIfDashboard(to);
    },
  },

  mounted() {
    this.loadFreshworksWidgetIfDashboard(this.$route);
  },

  methods: {
    loadFreshworksWidgetIfDashboard(route) {
      const scriptId = "freshworks-widget-script";

      // === Wenn NICHT auf Dashboard: Widget entfernen ===
      if (route.path !== "/dashboard") {
        // Falls Widget aktiv, per API entfernen
        if (typeof window.FreshworksWidget === "function") {
          try {
            window.FreshworksWidget("hide", "launcher"); // Versteckt das Widget
            window.FreshworksWidget("destroy"); // Optional: wirklich zerstören
          } catch (e) {
            console.warn("Freshworks konnte nicht deaktiviert werden", e);
          }
        }

        // Script entfernen
        const existingScript = document.getElementById(scriptId);
        if (existingScript) existingScript.remove();

        // Fallback: UI-Elemente manuell entfernen
        const widgetFrame = document.querySelector("iframe[src*='freshworks']");
        if (widgetFrame) widgetFrame.remove();

        // Globale Objekte löschen
        delete window.FreshworksWidget;
        delete window.fwSettings;

        return;
      }

      // === Wenn auf Dashboard, aber Script ist schon da → Nichts tun
      if (document.getElementById(scriptId)) return;

      // Konfiguration
      window.fwSettings = {
        widget_id: 36000001245,
      };

      if (typeof window.FreshworksWidget !== "function") {
        const n = function() {
          n.q.push(arguments);
        };
        n.q = [];
        window.FreshworksWidget = n;
      }

      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://widget.freshworks.com/widgets/36000001245.js";
      script.async = true;
      script.defer = true;
      script.id = scriptId;
      document.head.appendChild(script);
    },
  },
};
</script>

<style lang="scss">
@import "./assets/css/main.css";
</style>
